import React,{useState} from "react";
import { Row, Col,Menu, Drawer} from "antd";
import { NavLink } from "react-router-dom";
import UseWindowResize from '../../utilities/UseWindowResize';
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import mobileLogo from '../../components/img/mobile.svg'
import "./header.css";

const Header = () => {

  const [width] = UseWindowResize();
  const [visible, setVisible] = useState(false);
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };

  const logout = () => {
    localStorage.removeItem("oddruN@2021%");
  }
  return (
   width > 575 ? (
    <Row className="mainRowH" align="middle">
    <Col span={16} offset={4}>
      <div className="header">
        <img src={process.env.PUBLIC_URL + "/logo.svg"} className="logo" style={{order:2,margin:0}} alt=""/>
        <div className="routering" style={{order:1}}>
          <NavLink to="/jobs" style={{order:3}} activeClassName="selected" className="link-header">فرصت‌های شغلی</NavLink>
          <NavLink to="/requests" style={{order:2}} activeClassName="selected" className="link-header">درخواست‌ها</NavLink>
          <NavLink to="/login" style={{order:1}} 
          onClick={()=>logout()}
          activeClassName="selected" 
          className="link-header">خروج</NavLink>
        </div>
      </div>
    </Col>
  </Row>
   ):
   (<Row className="mainRowH" align="middle">
     <Col span={24}>
    <div className="header">
    <img src={mobileLogo} className="logo" style={{order:2,margin:0}}/>
    {visible ? (
        <CloseOutlined onClick={onClose}  className="menuIcon"/>
      ) : (
        <MenuOutlined  onClick={showDrawer} className="menuIcon"/>
      )}
       <Drawer
        title="Basic Drawer"
        placement="right"
        closable={false}
        onClose={onClose}
        open={visible}
        width="100%"
      >
        <>

          <Menu
          onClick={()=>setVisible(false)}
          mode="inline"
          className='jobs-menu'
        >
               <Menu.Item key="1">
               <NavLink to="/jobs" style={{order:3}} activeClassName="selected" className="link-header">فرصت‌های شغلی</NavLink>
          </Menu.Item>
          </Menu>

          <Menu
          onClick={()=>setVisible(false)}
          mode="inline"
          className='request-menu'
        >
              <Menu.Item key="1">
                <NavLink to="/requests" style={{order:2}} activeClassName="selected" className="link-header">درخواست‌ها</NavLink>
          </Menu.Item>
        </Menu>
          <Menu
          onClick={()=>setVisible(false)}
          mode="inline"
          className='logout-menu'
        >
              <Menu.Item key="1">
              <NavLink to="/login" style={{order:1}} 
          onClick={()=>logout()}
          activeClassName="selected" 
          className="link-header">خروج</NavLink>
          </Menu.Item>
        </Menu>

        </>
      </Drawer>
    </div>

     </Col>
   </Row>)
  );
};

export default Header;
